import "./page-company-2026.scss";
import "../../js/core";

$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      $(".slider-card-membership").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          568: {
            items: 2,
          },
          768: {
            items: 3,
          },
          1241: {
            items: 4,
          },
          1441: {
            items: 5,
          },
        },
        nav: true,
        dots: false,
        dotsEach: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-card-teams").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          568: {
            items: 2,
          },
          768: {
            items: 3,
          },
          992: {
            items: 4,
          },
        },
        nav: true,
        dots: false,
        dotsEach: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(".owl-carousel").each(function () {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });
    });
  });
});

// Animation Line scroll section Timeline
document.addEventListener("DOMContentLoaded", function () {
  const fillLine = document.getElementById("timelineFill");
  const firstRow = document.getElementById("first-timeline-row");
  const timelineSection = document.querySelector(".timeline-section");

  if (!fillLine || !firstRow || !timelineSection) return;

  function handleTimelineScroll() {
    const isMobile = window.innerWidth <= 991;
    const windowHeight = window.innerHeight;
    const triggerPoint = windowHeight / 2;

    const firstRowRect = firstRow.getBoundingClientRect();

    let startY;
    if (isMobile) {
      startY = firstRow.offsetTop + 28;
    } else {
      startY = firstRow.offsetTop + firstRow.offsetHeight / 2;
    }
    fillLine.style.top = startY + "px";

    const currentPointViewTop = isMobile
      ? firstRowRect.top + 28
      : firstRowRect.top + firstRowRect.height / 2;

    let progressHeight = 0;
    if (currentPointViewTop < triggerPoint) {
      progressHeight = triggerPoint - currentPointViewTop;
    }

    const allRows = document.querySelectorAll(".timeline-row");
    const lastRow = allRows[allRows.length - 1];

    if (lastRow) {
      let lastPointY;
      if (isMobile) {
        lastPointY = lastRow.offsetTop + 28;
      } else {
        lastPointY = lastRow.offsetTop + lastRow.offsetHeight / 2;
      }

      const maxLimit = lastPointY - startY;
      if (progressHeight > maxLimit) {
        progressHeight = maxLimit;
      }
    }

    fillLine.style.height = Math.floor(progressHeight) + "px";
  }

  window.addEventListener("scroll", handleTimelineScroll);
  window.addEventListener("resize", handleTimelineScroll);
  handleTimelineScroll();
});
